"use client"

import useWalkStatus from "@/utils/hooks/useWalkStatus";
import {useEffect, useState} from "react";
import {getCookie, setCookie} from "@/utils/hooks/useCookies";
import {useAppStore} from "@/store/AppStore";
import useUserInfo from "@/utils/hooks/useUserInfo";

// I cookie sono leggibili solo client-side. Lazy init li copia in
// stato al primo render, evitando setState dentro useEffect. I due
// effetti sottostanti riusano i flag per dedup notifiche; il cookie
// `loginNotification` viene comunque ri-controllato direttamente nel
// secondo effetto, quindi nessuna race se userInfo arriva tardi.
const readCookie = (key: string): string | null =>
  typeof document !== "undefined" ? getCookie(key) : null

export default function NotificationsSender() {
  const addNotification = useAppStore((state) => state.addNotification);
  const userInfo = useUserInfo()
  const walkStatus = useWalkStatus()
  const [distanceTarget] = useState<string | null>(() => readCookie('distanceTarget'))
  const [loginNotification] = useState<string | null>(() => readCookie('loginNotification'))

  /* NOTIFICATIONS SENDER */
  /* useEffect(() => {
    const sendNotification = (info: NotificationType): void => {
      if (permission === "granted") {
        console.log('Permission granted')
        navigator.serviceWorker.getRegistration().then((swr) => {
          console.log('swr', swr)
          if (swr) {
            swr.showNotification(info.title, {
              body: info.message,
              icon: "/Logo-Color-P.svg",
            });
          }
        })
      }
    };
    if (notifications && notifications.length > 0) {
      const firstNotification = notifications[0]
      console.log('Sending notification', firstNotification)
      sendNotification(firstNotification)
      removeNotification(0)
    }
  }, [notifications, permission, removeNotification])*/

  /* CHECK DISTANCE TARGET NOTIFICATION */
  useEffect(() => {
    if (walkStatus && !distanceTarget) {
      const kmFoot = Number(walkStatus?.total_distance.foot)
      const kmBike = Number(walkStatus?.total_distance.bicycle)

      const targetFootReached = kmFoot > 100
      const targetBikeReached = kmBike > 200
      if (!targetBikeReached && !targetFootReached) {
        const missingFoot = 100 - kmFoot
        const missingBike = 200 - kmBike
        addNotification({
          title: 'Ce la puoi fare!',
          message: `Ti mancano ${missingBike.toFixed()}km in bicicletta o ${missingFoot.toFixed()}km a piedi`
        })
        setCookie('distanceTarget', '1', {expires: 86400000})
      }

    }
  }, [addNotification, distanceTarget, walkStatus])


  /* LOGIN NOTIFICATIONS */
  useEffect(() => {
    if (userInfo && !loginNotification) {
      const cookie = getCookie('loginNotification')
      if (cookie) return
      addNotification({
        title: `Ciao ${userInfo?.name}`,
        message: `Ben ritrovato!`
      })
      setCookie('loginNotification', '1', {expires: 86400000})
    }
  }, [loginNotification, userInfo, addNotification])

  return null
}
